<template>
  <div class="faut-report">
    <h1>软件故障报告</h1>
    <div class="form-item">
      <label>一、查询时间</label>
      <div class="form-input">{{ labelForm.searchTime }}</div>
    </div>
    <div class="form-item" style="display: block;">
      <label style="width: 100%;">二、标识编号名称</label>
    </div>
    <div class="form-item">
      <ul>
        <li v-for="(item, key) in labelForm.labelNumbers" :key="key">
          <div class="num-item">
            <label>{{ item.label }}</label>
            <div><input v-model="item.value" /></div>
          </div>
        </li>
      </ul>
    </div>
    <div class="form-item">
      <label>三、故障现象</label>
      <div></div>
    </div>
    <div class="form-item">
      <label>&emsp;1.总是拍照无效</label>
      <div class="form-input line">
        <span>编号&nbsp;</span><input type="text" v-model="labelForm.fault1" />
      </div>
    </div>
    <div class="form-item">
      <label>&emsp;2.上传时长(>3秒)</label>
      <div class="form-input line">
        <input
          type="text"
          v-model="labelForm.fault8"
          style="width: 50px"
        /><span style="text-align: center">&nbsp;编号&nbsp;</span
        ><input type="text" style="width: 50px" v-model="labelForm.fault2" />
      </div>
    </div>
    <div class="form-item">
      <label>&emsp;3.总是显示上传</label>
      <div class="form-input line">
        <span>编号 </span><input type="text" v-model="labelForm.fault3" />
      </div>
    </div>
    <div class="form-item">
      <label>&emsp;4.对比图案变形</label>
      <div class="form-input line">
        <span>编号 </span><input type="text" v-model="labelForm.fault4" />
      </div>
    </div>
    <div class="form-item">
      <label>&emsp;5.图案对比框错位</label>
      <div class="form-input line">
        <span>编号 </span><input type="text" v-model="labelForm.fault5" />
      </div>
    </div>
    <div class="form-item">
      <label>&emsp;6.其它</label>
      <div class="form-input line">
        <span> 编号 </span
        ><input type="text" v-model="labelForm.fault7" style="width: 50px" />
      </div>
    </div>
    <div class="form-item">
      <label></label>
      <div class="form-input line">
        <span> 描述 </span
        ><textarea
          style="width: 100%"
          rows="5"
          v-model="labelForm.fault6"
        ></textarea>
      </div>
    </div>

    <div class="form-item">
      <label>四、</label>
      <div class="form-input">
        <input
          type="checkbox"
          style="vertical-align: bottom"
          v-model="labelForm.status"
        />全部正常
      </div>
    </div>
    <div class="footer" v-if="isSubmit">
      <button type="button" @click="submitForm">
        生成报告<br />分享至微信
      </button>
    </div>
  </div>
</template>
<script>
import { addFaultReport, getFaultReport } from "@/api/faultReport"
import { parseTime } from "@/utils/tools"
export default {
  data () {
    return {
      isSubmit: true,
      labelForm: {
        fault1: '',
        fault2: '',
        fault3: '',
        fault4: '',
        fault5: '',
        fault6: '',
        fault7: '',
        fault8: '',
        searchTime: parseTime(new Date(), '{y}.{m}.{d} {h}:{i}'),
        labelNumbers: [
          { check: false, label: '1', value: '' },
          { check: false, label: '2', value: '' },
          { check: false, label: '3', value: '' },
          { check: false, label: '4', value: '' },
          { check: false, label: '5', value: '' },
          { check: false, label: '6', value: '' },
        ]
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    submitForm () {
      this.labelForm.labelJson = JSON.stringify(this.labelForm.labelNumbers)
      this.labelForm.searchTime = this.labelForm.searchTime.replaceAll('.', '-')
      addFaultReport(this.labelForm).then(res => {
        this.$router.push({ path: '/faultReport', query: { key: res.data.id } })
        this.init()
      })
    },
    init () {
      if (this.$route.query.key) {
        this.isSubmit = false;
        getFaultReport(this.$route.query.key).then(res => {
          this.labelForm = res.data
          this.labelForm.labelNumbers = JSON.parse(this.labelForm.labelJson)
          this.labelForm.searchTime = this.labelForm.searchTime.replaceAll('-', '.')
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
body {
  background: #fff;
}
.faut-report {
  font-size: 0.32rem;
  padding: 0.32rem;
  h1 {
    font-size: 0.72rem;
    text-align: center;
    padding: 0.32rem;
  }
  .form-item {
    display: flex;
    padding: 0.2rem;
    label {
      display: block;
      flex: 0 3rem;
      line-height: 0.48rem;
    }
    .form-input {
      line-height: 0.48rem;
      &.line {
        display: flex;
        span {
          flex: 0 1rem;
        }
        input[type='text'] {
          flex: 1;
        }
      }
    }
    > div {
      flex: 1;
    }
    ul {
      li {
        width: 50%;
        display: inline-block;
        margin-bottom: 0.2rem;
        line-height: 0.48rem;
        .num-item {
          display: flex;
          label {
            flex: 0 0.8rem;
            text-align: center;
          }
          div {
            flex: 1;
            input {
              box-sizing: border-box;
              width: 100%;
            }
          }
        }
      }
    }
  }
  .footer {
    text-align: center;
    margin-top: 20px;
    button {
      color: #fff;
      background-color: #409eff;
      border-color: #409eff;
      border-radius: 4px;
      border: none;
      padding: 5px 10px;
      width: 50%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/faultReport/index.vue